import { useFormikContext, getIn } from 'formik';
import { RG, RadioGroupOption } from '@crazyegginc/hatch';

import { useEditorContext } from '../../editor-context';
import { AutoPositionSelector } from './AutoPositionSelector';

export function PopupPositionSelector({ fieldPath }) {
  const { readonly } = useEditorContext();
  const { values, setFieldValue } = useFormikContext();

  const value = getIn(values, fieldPath);
  const label = 'Position on page';

  return (
    <div className="flex space-x-7 self-start">
      <div>
        <div className="text-body-1 mb-2 block">{label}</div>
        <RG
          value={value}
          onChange={(newValue) => setFieldValue(fieldPath, newValue)}
          className="!self-start"
          disabled={readonly}
          aria-label={label}
        >
          <div className="flex h-9 items-center justify-center space-x-2.5 rounded-full bg-white-lilac-500 px-2.5">
            <RadioGroupOption
              size="sm"
              labelClass="!ml-1.25"
              option={{ value: 'bottomLeft', label: 'Left' }}
              disabled={readonly}
            />
            <RadioGroupOption
              size="sm"
              labelClass="!ml-1.25"
              option={{ value: 'bottomRight', label: 'Right' }}
              disabled={readonly}
            />
          </div>
        </RG>
      </div>
      <AutoPositionSelector />
    </div>
  );
}
